import request from '@/utils/request/index';
/**
 * 接口 [创建会话↗](https://yapi.fenxianglife.com/project/379/interface/api/42022) 的 **请求函数**
 *
 * @分类 [会话相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9893)
 * @请求头 `POST /session/create`
 * @更新时间 `2023-08-14 11:09:05`
 */
export const feimaChatSessionCreate = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatSessionCreateRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatSessionCreateResponse, OT>>(
    '/session/create',
    'POST',
    data,
    options
  );

/**
 * 接口 [会话列表↗](https://yapi.fenxianglife.com/project/379/interface/api/42028) 的 **请求函数**
 *
 * @分类 [会话相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9893)
 * @请求头 `POST /session/list`
 * @更新时间 `2023-08-10 12:12:03`
 */
export const feimaChatSessionList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatSessionListRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatSessionListResponse, OT>>(
    '/session/list',
    'POST',
    data,
    options
  );

export interface NoteSessionGetOrCreateRequest {
  sessionId?: number;
  botId: string;
  maskId?: number;
  conversation?: string;
  noteId: string;
}

/**
 * 笔记详情 AI 对话获取或创建专属会话。
 *
 * @请求头 `POST /session/note/getOrCreate`
 */
export const feimaChatSessionNoteGetOrCreate = (
  data: NoteSessionGetOrCreateRequest,
  options?: any
): Promise<number> =>
  request<any>('/session/note/getOrCreate', 'POST', data, options);

/**
 * 接口 [删除会话↗](https://yapi.fenxianglife.com/project/379/interface/api/42034) 的 **请求函数**
 *
 * @分类 [会话相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9893)
 * @请求头 `POST /session/delete`
 * @更新时间 `2023-07-07 17:32:43`
 */
export const feimaChatSessionDelete = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatSessionDeleteRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatSessionDeleteResponse, OT>>(
    '/session/delete',
    'POST',
    data,
    options
  );

/**
 * 接口 [会话聊天记录↗](https://yapi.fenxianglife.com/project/379/interface/api/42040) 的 **请求函数**
 *
 * @分类 [会话相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9893)
 * @请求头 `POST /session/conversation/list`
 * @更新时间 `2023-09-15 09:56:38`
 */
export const feimaChatSessionConversationList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatSessionConversationListRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatSessionConversationListResponse, OT>
  >('/session/conversation/list', 'POST', data, options);

/**
 * 接口 [发送消息↗](https://yapi.fenxianglife.com/project/379/interface/api/42046) 的 **请求函数**
 *
 * @分类 [会话相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9893)
 * @请求头 `POST /session/conversation/send`
 * @更新时间 `2023-09-14 14:31:20`
 */
export const feimaChatSessionConversationSend = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatSessionConversationSendRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatSessionConversationSendResponse, OT>
  >('/session/conversation/send', 'POST', data, options);

/**
 * 接口 [获取 ai 预测问题↗](https://yapi.fenxianglife.com/project/379/interface/api/42634) 的 **请求函数**
 *
 * @分类 [会话相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9893)
 * @请求头 `POST /session/get/anticipate/question`
 * @更新时间 `2023-08-14 14:31:51`
 */
export const feimaChatSessionGetAnticipateQuestion = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatSessionGetAnticipateQuestionRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatSessionGetAnticipateQuestionResponse,
      OT
    >
  >('/session/get/anticipate/question', 'POST', data, options);

/**
 * 接口 [更新内容标签↗](https://yapi.fenxianglife.com/project/379/interface/api/46594) 的 **请求函数**
 *
 * @分类 [会话相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9893)
 * @请求头 `POST /wxRobot/update/message/question/label`
 * @更新时间 `2023-12-09 13:49:12`
 */
export const feimaChatWxRobotUpdateMessageQuestionLabel = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWxRobotUpdateMessageQuestionLabelRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatWxRobotUpdateMessageQuestionLabelResponse,
      OT
    >
  >('/wxRobot/update/message/question/label', 'POST', data, options);

/**
 * 接口 发送定时任务 的 **请求函数**
 *
 * @分类 [会话相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9893)
 * @请求头 `POST /session/conversation/sendTimedTask`
 */
export const feimaChatSessionConversationSendTimedTask = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatSessionConversationSendTimedTaskRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatSessionConversationSendTimedTaskResponse,
      OT
    >
  >('/session/conversation/sendTimedTask', 'POST', data, options);

/**
 * 接口 修改定时任务 的 **请求函数**
 *
 * @分类 [会话相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9893)
 * @请求头 `POST /session/conversation/updateTimedTask`
 */
export const feimaChatSessionConversationUpdateTimedTask = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatSessionConversationUpdateTimedTaskRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatSessionConversationUpdateTimedTaskResponse,
      OT
    >
  >('/session/conversation/updateTimedTask', 'POST', data, options);

/**
 * 接口 撤回定时任务 的 **请求函数**
 *
 * @分类 [会话相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9893)
 * @请求头 `POST /session/conversation/cancelTimedTask`
 */
export const feimaChatSessionConversationCancelTimedTask = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatSessionConversationCancelTimedTaskRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatSessionConversationCancelTimedTaskResponse,
      OT
    >
  >('/session/conversation/cancelTimedTask', 'POST', data, options);

/**
 * 接口 获取机器人绑定的会话列表 的 **请求函数**
 *
 * @分类 [会话相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9893)
 * @请求头 `POST /session/botBindConversationList`
 */
export const feimaChatSessionBotBindConversationList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatSessionBotBindConversationListRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatSessionBotBindConversationListResponse,
      OT
    >
  >('/session/botBindConversationList', 'POST', data, options);

export interface BotBindConversationWithTagFan {
  id: number;
  botId?: string;
  botName?: string;
  botAvatar?: string;
  title?: string;
  maskType?: number;
  lastMessage?: string;
  sessionUserId?: string;
  updateTime?: string;
  ownerUserId?: string;
  defaultBot?: number;
  [property: string]: any;
}

export interface BotBindConversationTag {
  tagId: number;
  tagName: string;
  fanCount?: number;
  sessionIds?: number[];
}

export interface BotBindConversationListWithTagsResult {
  fans?: BotBindConversationWithTagFan[];
  tags?: BotBindConversationTag[];
}

export const feimaChatSessionBotBindConversationListWithTags = (
  data: { botId: string },
  options?: any
): Promise<BotBindConversationListWithTagsResult> =>
  request<any>(
    '/session/botBindConversationListWithTags',
    'POST',
    data,
    options
  );

export const feimaChatSessionFollowBot = (
  data: { botId: string },
  options?: any
) => request<any>('/session/followBot', 'POST', data, options);

/** 移除粉丝（从智能体粉丝列表中解绑指定会话）— 接口路径待确认 */
export const feimaChatSessionUnfollowFan = (
  data: { botId: string; sessionId: number },
  options?: any
) => request<any>('/session/unfollowFan', 'POST', data, options);

// ---- 手写接口（非自动生成）----

export interface McpToolOption {
  /** MCP 配置 ID，发送消息时作为 selectedMcpConfigId 传入 */
  id?: number;
  /** MCP Server 名称（前端展示用） */
  name?: string;
  [property: string]: any;
}

export interface SupportedChatModelConfigResult {
  /** 前端展示名称，如 "通义千问 Max" */
  displayName?: string;
  /** 模型 ID，传给 LLM API 的 model 字段 */
  modelId?: string;
  /** 该模型所属策略 */
  strategy?: string;
  /** 是否支持深度思考 */
  supportsThinking?: boolean;
  /** 是否支持联网搜索 */
  supportsWebSearch?: boolean;
  /** 是否支持文件附件 */
  supportsFile?: boolean;
  /** 是否支持图片附件 */
  supportsImage?: boolean;
  /** 是否支持视频附件 */
  supportsVideo?: boolean;
  /** 是否支持视频生成 */
  supportsVideoGeneration?: boolean;
  [property: string]: any;
}

export interface ChatFileDTO {
  /** 原始文件名，前端展示用 */
  fileName?: string;
  /** 文件类型：image / document / video */
  type?: string;
  /** OSS 文件地址 */
  url?: string;
  [property: string]: any;
}

export interface SessionToolsResult {
  /** 当前 Bot 绑定的 MCP 工具选项（供前端单选） */
  mcpTools?: McpToolOption[];
  /** 可选模型列表 */
  models?: SupportedChatModelConfigResult[];
  [property: string]: any;
}

export type SessionConversationItem = NonNullable<
  API.FeimaChatSessionConversationListResponse['data']['list']
>[number];

export interface MergedConversationDividerItem {
  type: 'DIVIDER';
  sessionId?: number;
  sessionTitle?: string;
  sessionCreateTime?: number | string;
  conversation?: null;
  [property: string]: any;
}

export interface MergedConversationMessageItem {
  type: 'MESSAGE';
  conversation?: SessionConversationItem | null;
  [property: string]: any;
}

export interface MergedConversationListResult {
  hasMore?: boolean;
  items?: Array<MergedConversationDividerItem | MergedConversationMessageItem>;
  list?: SessionConversationItem[];
  [property: string]: any;
}

export type MergedConversationListRequest = Omit<
  ToolTypes.GetRequestType<API.FeimaChatSessionConversationListRequest>,
  'sessionId'
> & {
  botId?: string | number;
};

export const feimaChatSessionConversationMergedList = (
  data: MergedConversationListRequest,
  options?: any
): Promise<MergedConversationListResult> =>
  request<any>('/session/conversation/mergedList', 'POST', data, options);

export const feimaChatSessionConversationSendNewsTimedTask = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatSessionConversationSendNewsTimedTaskRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatSessionConversationSendNewsTimedTaskResponse,
      OT
    >
  >('/session/conversation/sendNewsTimedTask', 'POST', data, options);

export const feimaChatSessionConversationUpdateNewsTimedTask = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatSessionConversationUpdateNewsTimedTaskRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatSessionConversationUpdateNewsTimedTaskResponse,
      OT
    >
  >('/session/conversation/updateNewsTimedTask', 'POST', data, options);

export const feimaChatNewsSourceListAll = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatNewsSourceListAllResponse, OT>
  >('/news/source/listAll', 'GET', {}, options);

/**
 * 接口 [获取会话工具选项] 的 **请求函数**
 *
 * @请求头 `POST /session/getTools`
 * 全局接口，不依赖具体会话 ID
 */
export const feimaChatSessionGetTools = (
  options?: any
): Promise<SessionToolsResult> =>
  request<any>('/session/getTools', 'POST', {}, options);

export interface SocialPublishTarget {
  bindingId: number;
  provider: string;
  platformSettings?: Record<string, unknown>;
}

export interface TimedTaskItem {
  taskId: number;
  botId: string;
  sessionId: number;
  sendSessionIds: number[];
  content: string;
  extJson?: Record<string, any>;
  masterConversationId: number;
  taskType: number;
  scheduledTime: string;
  status: number;
  recallFlag?: boolean;
  executeTime: string;
  failReason: string;
  sessionCount?: number;
  chatTimedTaskExt?: {
    title: string;
    tags: string;
    annotation: string;
    sendSessionIds: number[];
    /** 文生视频模型 ID，视频任务扩展信息里可能携带 */
    t2vModelId?: string;
  };
  newsTaskExt?: {
    taskType: number;
    keywords: string;
    timeRange: number;
    sourceIds: number[];
    fetchCount: number;
    pushIdentity: string;
    sendToSelected: number;
    deduplication: number;
    aiModel: string;
    aiStrategy: string;
    newsIds: number[];
    syncToSocial?: number | null;
    socialPublishMode?: 'NONE' | 'MANUAL' | 'AUTO' | null;
    socialPublishTargets?: SocialPublishTarget[] | null;
  };
  syncToSocial?: number | null;
  socialPublishMode?: 'NONE' | 'MANUAL' | 'AUTO' | null;
  socialPublishTargets?: SocialPublishTarget[] | null;
  maxExecutionCount?: number | null;
  recurrenceType?: number;
  recurrenceWeekDays?: number[];
  createTime: string;
  updateTime: string;
  /** 文生视频模型 ID，非空时定时任务执行走文生视频链路 */
  t2vModelId?: string;
}

export interface TimedTaskListParams {
  size?: number;
  page?: number;
  isLimit?: boolean;
  lastId?: number;
  botId?: string;
  status?: number;
  sortType?: number;
}

export interface TimedTaskListResult {
  list: TimedTaskItem[];
  endPage: boolean;
}

export interface TimedTaskNewsInfoItem {
  content?: string;
  createTime?: string;
  fetchTime?: string;
  id?: number;
  publishTime?: string | number;
  sourceName?: string;
  sourceType?: number;
  sourceUrl?: string;
  summary?: string;
  title?: string;
  updateTime?: string;
  [property: string]: any;
}

export interface TimedTaskResultDetail {
  botId?: string;
  chatTimedTaskExt?: TimedTaskItem['chatTimedTaskExt'];
  content?: string;
  createTime?: string;
  executeTime?: string;
  extJson?: Record<string, any>;
  failReason?: string;
  groupInfoId?: string;
  masterConversationId?: number;
  taskId?: number;
  newsTaskExt?: TimedTaskItem['newsTaskExt'];
  syncToSocial?: number | null;
  socialPublishMode?: 'NONE' | 'MANUAL' | 'AUTO' | null;
  socialPublishTargets?: SocialPublishTarget[] | null;
  newsInfoList: TimedTaskNewsInfoItem[];
  noteId?: string;
  scheduledTime?: string;
  sendSessionIds?: number[];
  sessionId?: number;
  status?: number;
  taskType?: number;
  updateTime?: string;
  [property: string]: any;
}

export const feimaChatSessionConversationTimedTaskList = (
  data: TimedTaskListParams,
  options?: any
): Promise<TimedTaskListResult> =>
  request<any>(
    '/session/conversation/timedTask/mergedList',
    'POST',
    data,
    options
  );

export const feimaChatSessionConversationTimedTaskResultDetail = (
  data: { taskId: number },
  options?: any
): Promise<TimedTaskResultDetail> =>
  request<any>(
    '/session/conversation/timedTask/detail',
    'POST',
    data,
    options ?? { noMessage: true }
  );

export const feimaChatSessionMsgShareLink = (
  data: {
    conversationIds: number[];
    botId?: string | number;
  },
  options?: any
): Promise<{ shareToken: string }> =>
  request<any>('/session/share/create', 'POST', data, options);

export const feimaChatSessionMsgShareDetail = (
  data: { page?: number; shareToken: string; size?: number },
  options?: any
): Promise<{
  messages?: any[];
  page?: number;
  size?: number;
  title?: string;
  total?: number;
}> => request<any>('/session/share/view', 'POST', data, options);

export interface NoteAiGenerateRequest {
  content?: string;
  type?: string;
  usedTitles?: string[];
  [property: string]: any;
}

export interface NoteAiGenerateResult {
  summary?: string;
  title?: string;
  [property: string]: any;
}

export const feimaChatSessionConversationNoteAiGenerate = (
  data: NoteAiGenerateRequest,
  options?: any
): Promise<NoteAiGenerateResult> =>
  request<any>('/session/conversation/note/aiGenerate', 'POST', data, options);

export interface SessionConversationStopRequest {
  sessionId: number;
}

export const feimaChatSessionConversationStop = (
  data: SessionConversationStopRequest,
  options?: any
): Promise<any> =>
  request<any>('/session/conversation/stop', 'POST', data, options);

export interface VideoTaskQueryRequest {
  conversationId?: number;
  videoTaskId?: string;
  [property: string]: any;
}

export interface VideoTaskQueryResult {
  conversationId?: number;
  videoTaskId?: string;
  /** PENDING / RUNNING / SUCCEEDED / FAILED */
  videoTaskStatus?: string;
  videoUrl?: string;
  [property: string]: any;
}

export const feimaChatSessionVideoQueryTask = (
  data: VideoTaskQueryRequest,
  options?: any
): Promise<VideoTaskQueryResult> =>
  request<any>(
    '/session/video/queryTask',
    'POST',
    data,
    options ?? { noMessage: true }
  );
